module.exports = __webpack_public_path__ + "assets/swiss.265da09c.svg";